import { render } from "./SearchInfoPanel.vue?vue&type=template&id=007cde08&scoped=true"
import script from "./SearchInfoPanel.vue?vue&type=script&lang=js"
export * from "./SearchInfoPanel.vue?vue&type=script&lang=js"

import "./SearchInfoPanel.vue?vue&type=style&index=0&id=007cde08&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007cde08"]])

export default __exports__